//
// Search Box
//
// Shows and hides the reset button depending on whether the
// search box has content inside it or not
// ---------------------------------------------------------------------------

'use strict';

const config = {
    target: '.js-search',
    activeClass: 'is-active'
};

let form = $(config.target).closest('form');

form.on('keyup', function() {
    let search = $(this);
    if (!search.is(config.target)) {
        search = search.find(config.target);
    }

    if (search.find('input').val()) {
        search.addClass(config.activeClass);
    } else {
        search.removeClass(config.activeClass);
    }
});

form.on('reset', function(e) {
    e.preventDefault();

    let search = $(this);
    if (!search.is(config.target)) {
        search = search.find(config.target);
    }

    search.find('input').val(null);
    search.removeClass(config.activeClass);
});



// WEBPACK FOOTER //
// ./src/js/components/search-box.js